/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Switch({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M5.424 2.076a.6.6 0 0 1 0 .848L3.95 4.4H13.5a.6.6 0 1 1 0 1.2H3.949l1.475 1.476a.6.6 0 0 1-.848.848l-2.5-2.5a.6.6 0 0 1 0-.848l2.5-2.5a.6.6 0 0 1 .848 0Zm5.152 6a.6.6 0 0 1 .848 0l2.5 2.5a.6.6 0 0 1 0 .848l-2.5 2.5a.6.6 0 1 1-.848-.848l1.476-1.476H2.5a.6.6 0 1 1 0-1.2h9.552l-1.476-1.476a.6.6 0 0 1 0-.848Z" clipRule="evenodd" /></svg>;
}
;